import { constants, mediaQueryStyles } from "@newsela/angelou";

const { mediaQuery } = mediaQueryStyles;
const {
  BreakpointNames: { md, lg },
} = constants.breakpoints;
const { ui } = constants.colors;

export const rootCss = (isDisabled = false, isMobile = false) => ({
  ...(isDisabled
    ? {
        cursor: "not-allowed",
        pointerEvents: "none !important",
        opacity: 0.4,
      }
    : {}),
  ...(isMobile
    ? {
        height: "32px",
        padding: "4px",

        [mediaQuery.between(md, lg)]: {
          height: "48px",
          padding: "12px",
        },
      }
    : {}),
});

export const lockIconCss = (
  isPrintDisabled: boolean,
  isButtonIcon = false,
) => ({
  color: isButtonIcon ? "inherit" : ui.neutral[500],
  display: isPrintDisabled ? "inline" : "none",
  height: "20px",
  marginRight: "0.5em",
  verticalAlign: "text-bottom",
});

export const iconCss = {
  display: "none",
};

export const printIconCss = {
  height: "24px",
};
